//
//
//

import G2 from '@antv/g2';

export default {
  name: 'linechart',
  props: ['chartData', 'chartId'],
  data() {
    return {
      data: [],
      id: '',
      lineChar: {}
    };
  },
  watch: {
    chartData(newVal) {
      this.data = newVal;
      this.lineChar.changeData(this.data);
    }
  },
  created() {
    this.id = this.chartId;
    this.data = this.chartData;
  },
  mounted() {
    this.lineChar = new G2.Chart({
      container: this.id,
      forceFit: true,
      height: document.querySelector('#' + this.id + '').clientHeight,
      width: document.querySelector('#' + this.id + '').clientWidth,
      padding: 'auto'
    });
    this.lineChar.source(this.data);
    this.lineChar.tooltip(false);
    this.lineChar.legend(false);
    this.lineChar
      .line()
      .position('date*value')
      .color('name')
      .size(4);
    this.lineChar.point().position('date*value');
    this.lineChar.render();
  }
};
